module.exports = __webpack_public_path__ + "static/media/frankEijsvogels.31601a69.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/frankEijsvogels.jpg
// module id = 1672
// module chunks = 1